import React from 'react';
import { Show } from '@refinedev/antd';
import { useShow } from '@refinedev/core';
import { Tag, theme } from 'antd';
import { Field } from '../../components/Field';
import { LocalizedContentShow } from '../../components/LocalizedContentTabs';

interface AppStringDto {
  id: string;
  key: string;
  namespace: string;
  description?: string | null;
  defaultText: string;
  translations?: Record<string, { text?: string }> | null;
  createdAt: string;
  updatedAt: string;
}

export const AppStringShow: React.FC = () => {
  const { token } = theme.useToken();
  const { queryResult } = useShow<AppStringDto>({ resource: 'app-strings' });
  const item = queryResult?.data?.data;

  if (!item) {
    return <div style={{ color: token.colorTextSecondary }}>Loading...</div>;
  }

  return (
    <Show resource="app-strings">
      <div style={{ padding: '8px 0' }}>
        <LocalizedContentShow
          record={item}
          fields={[{ key: 'defaultText', translationKey: 'text', label: 'Text', textarea: true }]}
        />

        <div
          style={{
            borderTop: `1px solid ${token.colorBorderSecondary}`,
            paddingTop: 16,
          }}
        >
          <Field label="Key">{item.key}</Field>
          <Field label="Namespace">
            <Tag>{item.namespace}</Tag>
          </Field>
          <Field label="Description">{item.description || '—'}</Field>
          <Field label="Updated At">{new Date(item.updatedAt).toLocaleString()}</Field>
        </div>
      </div>
    </Show>
  );
};
